<!-- 任务4 -->
<template>
    <div>
      <div class="course_Task4">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">
              任务得分：10 分
            </p>
          </template>
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>任务名称：</p>
          <p style="min-height: 21px;">{{taskInfo.taskTitle}}</p>
          <p class="fontB"><i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：</p>
          <p style="min-height: 21px;">{{taskInfo.taskScore}}分</p>
          <p class="fontB"><i class="el-icon-document-copy icon_"></i>报告要求：</p>
          <el-row class="aljj">
            <el-row v-html="taskInfo.assessmentContent"></el-row>
          </el-row>
          <p class="fontB"><i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i>报告参考模板：</p>
          <el-row style="border:1px solid #D3D3D3;width: 50%;padding:20px;">
            <template v-for="(item ,index) in taskInfo.teacherOpenCourseHandsOnSimulationTasksFileList">
              <el-row class="mb10">
                <el-col :span="16">
                  <el-image class="course_Task4_img" :src="mb_d"></el-image>
                  <p class="m0 limit_line_one l_h40">{{item.fileName}}</p>
                  <!-- <p class="mb1">
                    120.kb
                    file：{{$matchType(item.fileName)}}
                  </p> -->
                </el-col>
                <el-col :span="8" class="t_r lineContent">
                  <el-button class="but_task" size="small" @click="downloadFile(item)" icon="el-icon-download" plain>下载</el-button>
                </el-col>
              </el-row>
            </template>
          </el-row>
          <!-- <p class="fontB"><i class="el-icon-upload2 icon_" style="color: #8a39c2;"></i>报告上传：</p>
          <el-row>
            <el-upload
              class="upload-demo"
              drag
              action="https://jsonplaceholder.typicode.com/posts/"
              multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">上传文件，仅支持PDF格式</div>
            </el-upload>
            <el-row style="margin: 10px 0;">
              <el-button type="primary">提 交</el-button>
            </el-row>
          </el-row> -->
        </el-row>
      </div>
    </div>
</template>
<script>

export default {
  name: 'Task4',
  props: {
    examType: { //考试类型 1：考试 2：查看成绩
      type: String,
      default: function(){
        return 1;
      }
    },
    taskId: { //任务ID
      type: String,
      default: function(){
        return "";
      }
    },
  },
  data() {
    return {
      mb_d:require("../../../../images/course/mb_d@2x.png"),
      taskInfo:{} //任务详情
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    getInfo(){ //获取详情
      this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do",{taskId:this.taskId}).then((ret) =>{
        if(ret.code == 0){
          this.taskInfo = ret.data;
          this.tableData = ret.data.handsOnTaskProblemVo;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    downloadFile(item){ //下载文件
      this.$downLoadFile(item.fileUrl,item.fileName);
    }
  }
};
</script>
<style  lang="less">
  .course_Task4{
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .course_Task4_img{
      width: 40px;
      height: 40px;
      float: left;
      margin-right: 20px;
    }
    .but_task{
      color: #2789E2;border-color:#2789E2 ;margin-top: 5px;
    }
    .has-gutter{
      th{
        border-color:#E5E5E5;
        background-color: #EFF2F7;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/PracticalTraining/Task5.vue